













import Vue from 'vue';

import FilterPill from './FilterPill.vue';
import { clearAllFilters } from '../store/actions';
import { IState, ISelectedFilterValue } from '../store/state';

interface ISelectedFiltersComputed {
	selectedFilters: ISelectedFilterValue[];
}

interface ISelectedFiltersMethods {
	deselectAll(): void;
}

export default Vue.extend<{}, ISelectedFiltersMethods, ISelectedFiltersComputed, {}>({
	computed: {
		selectedFilters() {
			return (this.$store.state as IState).selectedFilterValues
		}
	},
	methods: {
		deselectAll(){
			this.$store.dispatch(clearAllFilters(undefined));
		}
	},
	components: {
		FilterPill
	}
})
